import {static507 } from "./507"
import {static509 } from "./509"
import {static716 } from "./716"
import {static718 } from "./718"

export const staticPagesIDs = [507, 509, 716, 718]
export const staticPagesMapping = {
    507: static507,
    509: static509,
    718: static718,
    716: static716,
}